import { createSelector } from 'reselect';

export const selectedProvisionalClaim = (state: any) => {
  return state.get('provisionalClaimDetails');
};

const makeSelectProvisionalClaimDetails = () =>
  createSelector(selectedProvisionalClaim, provisionalClaimDetails => {
    if (
      provisionalClaimDetails &&
      provisionalClaimDetails.get('provisionalClaimDetails')
    ) {
      return provisionalClaimDetails.get('provisionalClaimDetails').toJS();
    }
    return {};
  });

const makeSelectProvisionalClaimReference = () =>
  createSelector(selectedProvisionalClaim, provisionalClaimDetails => {
    if (
      provisionalClaimDetails &&
      provisionalClaimDetails.get('provisionalClaimReference')
    ) {
      return provisionalClaimDetails.get('provisionalClaimReference');
    }
    return '';
  });

const makeSelectUpdateClaimNumberResult = () =>
  createSelector(selectedProvisionalClaim, provisionalClaimDetails => {
    if (
      provisionalClaimDetails &&
      provisionalClaimDetails.get('updateClaimNumberResult')
    ) {
      return provisionalClaimDetails.get('updateClaimNumberResult').toJS();
    }
    return {
      isClaimNumberExist: false,
      isProvisionalClaimUpdated: false,
    };
  });

export {
  makeSelectProvisionalClaimDetails,
  makeSelectProvisionalClaimReference,
  makeSelectUpdateClaimNumberResult,
};
